import React, { FunctionComponent } from 'react'

const TpaWidgetNative: FunctionComponent<any> = (props) => {
	const emptyComponent = () => <div />
	const ReactComponent = props.ReactComponent || emptyComponent
	const style = props.host && props.host.isResponsive ? {} : { height: 'auto' }
	return (
		<div id={props.id} style={style}>
			<ReactComponent {...props} />
		</div>
	)
}

export default TpaWidgetNative
